





















import {
  Prop,
  Watch,
  Vue,
  Component,
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import {
  EbtoClaim,
  EbtoVerificationCode
} from "@/employee/route-names";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useEbtoStore } from "@/shared/store/ebto";
import { useThemeStore } from "@/shared/store/theme";

const HsabPartnerId = 15;

@Component({
  components: {
    Logo
  }
})
export default class HsabLoginWrapper extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();
  ebtoStore = useEbtoStore();
  themeStore = useThemeStore();


  @Prop()
  campaignKey: string;

  mounted (): void {
    this.portalCustomizationStore.getUserLogo(HsabPartnerId);
    this.ebtoStore.ebtoGetCampaign(this.campaignKey || this.ebtoStore.campaignId);
    this.themeStore.getTheme({ partnerId: HsabPartnerId, employerId: 0, forceUpdate: true });

    if (!this.ebtoStore.isVerified && !(this.$route.name === EbtoClaim || this.$route.name === EbtoVerificationCode)) {
      this.resetForm();
    }
  }

  get displayLogoutButton (): boolean {
    return this.$route.name !== EbtoClaim;
  }

  resetForm (): void {
    const storedCampaignId = this.ebtoStore.campaignId;
    this.ebtoStore.resetState();
    this.$router.push({ name: EbtoClaim, query: { c: storedCampaignId } });
  }

  @Watch("ebtoStore.autoLogout")
  formTimoutWatcher (newValue): void {
    if (newValue) {
      this.resetForm();
    }
  }
}
